import { Divider, Form } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { updatePageStepToFinish } from "../../../../../actions/globalActions";
import AlertBox from "../../../../../CommonComponents/AlertBox";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
import { DisplayFlex, Spinner } from "../../../../../CommonComponents/commonStyles";
import { resetAllZipFields, resetZipCode } from "../../../../../CommonComponents/Zipcode/actions";
import history from "../../../../../history/history";
import { handleDisabled, initiateTracking, recordError } from "../../../../../utils/commonUtil";
import globalRegex from '../../../../../utils/regexMap';
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../../utils/sessionUtil";
import { addSecondaryAdvisor, clearEditProfileError, clearSecondaryAdvRes, disableButton, handleResetFormAddress, handleResetFormEmail, handleResetFormInfo, handleResetFormPhone, handleResetFormRelatedContributor, handleResetSecFormBasicInfo, isSecondaryAdvisor, jsonTemp, myAccountMandatoryMissing, postAccountAdvisor, reset, step1Edit,onPhoneChangeHandler,onEmailChangeHandler } from "../../../actions";
import { AdvisoryFormWrapper, DisplayFlexSpaceMobile, FormContainer, GhostButtonReset, InfoMsg, MyAccountMandatoryMessage, RowWrapper, ShowErrorMessage } from "../styles";
import AddressForm from "./AddressForm";
import EmailForm from "../../../../../CommonComponents/Forms/EmailInputForm";
import PhoneForm from "../../../../../CommonComponents/Forms/PhoneInputForm";
import { DividerWrap } from "./RelatedContributor/styles";
import UserInfoForm from "./UserInfoForm";

let isNewSecondaryAdvisor = false;
let errorVariable;
class AdvisorForm extends React.Component {

  constructor(props) {
    super(props);
    isNewSecondaryAdvisor = this.props.addSecondaryAdv;
    this.state = {
      show: false,
      type: "",
      reset: false,
      enableReset: false,
      isUserInfo: false,
      isEmailInfo: false,
      isPhoneInfo: false,
      isAddressInfo: false,
      isInvalidAdvisor: false,
      isSubmit:false
    };
    this.phoneFormRef = React.createRef();
    this.emailFormRef = React.createRef();
    this.resetPopupContent = {
      heading: "Clear Information",
      line1: "<p>Clearing will delete all entered information on the page</p><p>Do you want to continue?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };
    this.removePopupContent = {
      heading: "Remove secondary advisor",
      line1: "<p>Are you sure you want to remove the secondary advisor?</p><p>Do you want to continue?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };
    this.exitPopupContent = {
      heading: "Exit",
      line1: "<p>Exitting will discard all information in the flow.</p><p>Do you want to continue?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };
    this.geminiUser = isGeminiUser();
  }

  advisorType = this.props.advisorType;
  handleEditReset = () => {
    this.setState({
      show: false,
      type: "reset",
      reset: true
    });
    let postData = {
      fundName: this.props.accountName,
      userId: this.props.webAccessInfo.userId,
      referralCode: {
        referralCodeValue: "",
        comment: ""
      },
      advisors: [
        {
          primary: true,
          title: this.props.primaryAdvisor.info.title,
          firstname: this.props.primaryAdvisor.info.firstname,
          middlename: this.props.primaryAdvisor.info.middlename,
          lastname: this.props.primaryAdvisor.info.lastname,
          suffix: this.props.primaryAdvisor.info.suffix,
          gender: this.props.primaryAdvisor.info.gender,
          dob: this.props.primaryAdvisor.info.dob,
          ssn: this.props.primaryAdvisor.info.ssn,
          phones: this.props.primaryAdvisor.phone.phone,
          emails: this.props.primaryAdvisor.email.email,
          addresses: this.props.primaryAdvisor.addresses.addresses,
          deliveryMethod: this.props.primaryAdvisor.info.deliveryMethod,
          relatedDonor: this.props.primaryAdvisor.relatedDonor.relatedDonor
            ? this.props.primaryAdvisor.relatedDonor.relatedDonor
            : []
        },
        {
          primary: false,
          title: this.props.secondaryAdvisor.info.title,
          firstname: this.props.secondaryAdvisor.info.firstname,
          middlename: this.props.secondaryAdvisor.info.middlename,
          lastname: this.props.secondaryAdvisor.info.lastname,
          suffix: this.props.secondaryAdvisor.info.suffix,
          gender: this.props.secondaryAdvisor.info.gender,
          dob: this.props.secondaryAdvisor.info.dob,
          ssn: this.props.secondaryAdvisor.info.ssn,
          phones: this.props.secondaryAdvisor.phone.phone,
          emails: this.props.secondaryAdvisor.email.email,
          addresses: this.props.secondaryAdvisor.addresses.addresses,
          deliveryMethod: this.props.secondaryAdvisor.info.deliveryMethod
        }
      ],
      legacyOptions: this.props.legacyOptions.map(val => {
        if (val.optionId === 1 || val.optionId === 2) {
          return {
            optionName: val.optionName,
            optionId: val.optionId,
            selected: "",
            percentage: val.percentage,
            successorAdvisor: val.successorAdvisor.successorAdvisor,
            successionPlanGranteeOrg: ""
          };
        }
        if (val.optionId === 3 || val.optionId === 5) {
          return {
            optionName: val.optionName,
            optionId: val.optionId,
            selected: "",
            percentage: val.percentage,
            successionPlanGranteeOrg: "",
            successorAdvisor: ""
          };
        }
        if (val.optionId === 4) {
          return {
            optionName: val.optionName,
            optionId: val.optionId,
            selected: "",
            percentage: val.percentage,
            successionPlanGranteeOrg: val.successorAdvisor.successorAdvisor,
            successorAdvisor: ""
          };
        }
      })
    };
    this.props.jsonTemp({
      tempJSON: postData
    });
  };
  getSnapshotBeforeUpdate(oldProps) {
    const { addSecondaryAdv } = this.props;
    if (
      this.props.addSecondaryRes&&
      addSecondaryAdv
    ) {
      history.push("/my-account",
        {
          showSuccessMessage:true,
          messageText:"Account Advisor"
        }
      );
    }
    return null;
  }
  handleReset = advisorType => {
    this.props.resetAllZipCode();
    const { addSecondaryAdv } = this.props;
    this.setState({
      show: !this.state.show
    });
    this.props.reset({
      [advisorType]: {
        reset: true
      }
    });
    window.scrollTo(0, 0);
    let emailArr = [];
    let phoneArr = [];
    let addrArr = [];
    let relContr = [];
    emailArr.push({ emailtype: "", emailId: "", key: 1, primary: true });
    phoneArr.push({ phonetype: "", phonenumber: "", key: 1, primary: true });
    addrArr.push({
      addresstype: "",
      line1: "",
      line2: "",
      line3: "",
      zipcode: "",
      city: "",
      state: "",
      country: "0",
      primary: true,
      key: 1
    });
    relContr.push({ name: "", relationship: "", key: 0 });
    if (
      (this.props.userType === "primary" && this.advisorType === "Primary") ||
      (this.props.userType === "secondary" && this.advisorType === "Secondary") ||
      (this.props.userType === "primary" && addSecondaryAdv)
    ) {
      this.props.handleResetFormEmail({
        [advisorType]: {
          email: emailArr
        }
      });
      this.props.handleResetFormRelatedContributor({
        [advisorType]: {
          relatedDonor: relContr
        }
      });
      this.props.handleResetFormPhone({
        [advisorType]: {
          phone: phoneArr
        }
      });
    }
    if (this.props.userType === "primary" && addSecondaryAdv) {
      this.props.handleResetSecFormBasicInfo({
        ["secondaryAdvisor"]: {
          title: "",
          firstname: "",
          middlename: "",
          lastname: "",
          suffix: "",
          dob: "",
          gender: "",
          confirmSSN: "",
          ssn: "",
          deliveryMethod: "E-Delivery"
        }
      });
    }
    this.setState({
      isUserInfo: true,
      isAddressInfo: true
    },()=>{
      const {resetFields:phoneReset }  = this.phoneFormRef.current.form;
      const {resetFields:emailReset }  = this.emailFormRef.current.form;
        phoneReset();
        emailReset();
    });
    
    if (
      (this.props.userType === "primary" || this.props.userType === "secondary" || this.props.userType === "full") &&
      this.advisorType === "Primary"
    ) {
      this.props.handleResetFormAddress({
        ["primaryAdvisor"]: {
          addresses: addrArr
        }
      });
    }
    if (
      (this.props.userType === "primary" || this.props.userType === "secondary" || this.props.userType === "full") &&
      this.advisorType === "Secondary"
    ) {
      this.props.handleResetFormAddress({
        ["secondaryAdvisor"]: {
          addresses: addrArr
        }
      });
    }
  };
  handleResetSecondary = advisorType => {
    this.handleReset(advisorType);
    window.scrollTo(0, 0);
    this.props.handleResetFormInfo({
      [advisorType]: {}
    });
  };
  enableResetButton = () => {
    this.setState({
      enableReset: true
    });
  };

  createSecAdvisorBody = data => {
    const { countries = [] , gender = [], title = [], suffix = [], states = []} = this.props.dropdownValues;
    const userData = getAccountData();
    let gndr, prefix, sufx;
    if (data.info.gender) gndr = gender.find(o => o.value === data.info.gender);
    if (data.info.title) prefix = title.find(o => o.value === data.info.title);
    if (data.info.suffix) sufx = suffix.find(o => o.value === data.info.suffix);
    
    if (data.addresses && data.addresses.addresses) {
      data.addresses.addresses.forEach(data => {
        if (data.country === "0") {
          this.props.dropdownValues &&
            this.props.dropdownValues.states &&
            this.props.dropdownValues.states.find(item => {
              if (item.value === data.state || item.desc === data.state) {
                data.state = item.desc;
              }
            });
        }
      });
      

    let addressArray =  data.addresses.addresses.map((addr,index)=>{
      let country = countries.find(o => o.value === addr.country);
      return {
        addressType:addr.addresstype,
        addressLine1:addr.line1,
        addressLine2:addr.line2||null,
        addressLine3:addr.line3||null,
        city:addr.city,
        state:addr.state,
        zipCode:addr.zipcode,
        country:country?.desc,
        primary:addr.primary?1:0
      }
    })

      const deletedAddress = this.props.secondaryDeletedAddress.filter((elm) => {
        if (elm.addressType !== "") {
          return !(addressArray.some((val) => {
            return val.addressType == elm.addressType
          }))
        }
        return false
      })
 
   let  body = {
      accountId : getPrimaryAccount().userId,
      requestedBy:getAccountData().partyId,
      title:prefix ? prefix.desc:null,
      firstName:data.info.firstname,
      middleName:data.info.middlename ? data.info.middlename : null,
      roleType:"Account Advisor - Full Access",
      lastName:data.info.lastname,
      suffix:sufx ?sufx.desc:null,
      gender:gndr ? gndr.value:null,
      dateOfBirthStr:moment(data.info.dob).format("MM/DD/YYYY"),
      ssn:data.info.ssn,
      deliveryMethod:"E-Delivery",
      phones:data.phone.phone.map((phn,index)=>{return  {
        phoneType:phn.phonetype,
        phoneNumber:phn.phonenumber
      }}),
      emails:data.email.email.map((eml,index)=>{
        return {
          emailType:eml.emailtype,
          emailId:eml.emailId
        }
      }),
      addresses:[...addressArray,...deletedAddress]
    }
  
    return body;
  }
};
  verifyDobForInvalidDate = dob => {
    if (dob && dob.toLowerCase() === "invalid date") {
      return null;
    }
    if (dob) {
      return moment(dob, "MM/DD/YYYY").format("YYYY-MM-DD");
    } else {
      return dob;
    }
  };
  finalAdvisorData = (storeData, primary) => {
    const {countries = [],suffix,title} = this.props.dropdownValues
    let primaryAdvisor = {};
    let apiData = this.props.apiData;
    let currentAdvisor = apiData.filter(data => data.primary === primary);
    primaryAdvisor.primaryAccountContact = null;
    primaryAdvisor.name = null;
    primaryAdvisor.phone = null;
    primaryAdvisor.email = null;
    primaryAdvisor.address = null;
    primaryAdvisor.primary = primary;
    primaryAdvisor.title = title.find((titl)=>{
      return titl.value === storeData.info.title;
    })?.desc
    primaryAdvisor.firstName = storeData.info.firstname;
    primaryAdvisor.middleName = storeData.info.middlename;
    primaryAdvisor.lastName = storeData.info.lastname;
    primaryAdvisor.suffix = suffix.find((suf)=>{
      return suf.value === storeData.info.suffix;
    })?.desc
    primaryAdvisor.gender = storeData.info.gender;
    primaryAdvisor.ssn = storeData.info.ssn;
    primaryAdvisor.partyId = currentAdvisor[0] ? currentAdvisor[0].partyId : getAccountData().partyId;
    primaryAdvisor.deliveryMethod = storeData.info.deliveryMethod;
    primaryAdvisor.dob = this.verifyDobForInvalidDate(storeData.info.dob);
    let relatedDonor = storeData.relatedDonor.relatedDonor;
    primaryAdvisor.relatedDonor = relatedDonor === undefined ? null : relatedDonor;
    primaryAdvisor.userId = storeData.userId.userId;
    let phones = storeData.phone.phone;
    primaryAdvisor.phones = phones.map(phone => {
      return {
        phoneType: phone.phonetype,
        phoneNumber: phone.phonenumber,
      };
    });
    let emails = storeData.email.email;
    primaryAdvisor.emails = emails.map(email => {
      return {
 
        emailType: email.emailtype,
        emailId: email.emailId,
      };
    });
    let addresses = storeData.addresses.addresses;
    addresses.forEach(data => {
      if (data.country === "0") {
        this.props.dropdownValues &&
          this.props.dropdownValues.states &&
          this.props.dropdownValues.states.find(item => {
            if (item.value === data.state || item.desc === data.state) {
              data.state = item.desc;
            }
          });
      }
    });
     const finalAddress = addresses.map(address => {
      let countrydesc = countries.find((cntr)=>{
        return  cntr.value === address.country
      })
      return {
        addressType: address.addresstype,
        addressLine1: address.line1,
        addressLine2: address.line2,
        addressLine3: address.line3,
        city: address.city,
        state: address.state,
        zipCode: address.zipcode,
        country: countrydesc?.desc,
        primary: address.primary === true ? "1" : "0",
        addressUpdated: address.addressUpdated ? address.addressUpdated : false
      };
    });
    const deletedAddressWithType = primary?this.props.primaryDeletedAddress:this.props.secondaryDeletedAddress;
    const deletedAddress =( deletedAddressWithType||[]).filter((elm)=>{
      if (elm.addressType != "") {
        return !(finalAddress.some((val) => {
          return val.addressType == elm.addressType
        }))
      }
      return false;
    })

    primaryAdvisor.addresses = [...finalAddress,...deletedAddress];
    return primaryAdvisor;
  };
  updateAccountAdvisor = () => {
    let advisors = [];
    let primaryAdvisor = this.finalAdvisorData(this.props.primaryAdvisor, true);
    advisors.push(primaryAdvisor);
    if (this.props.isSecondarySelected && this.props.isSecondarySelected.isSecondaryAdvisor) {
      let secondaryAdvisor = this.finalAdvisorData(this.props.secondaryAdvisor, false);
      advisors.push(secondaryAdvisor);
    }
    if(!this.state.isSubmit)
    {
    const data = {
      method: "POST",
      page: "MyAccountEditAccountAdvisor",
      url: "/DP/Entity/UpdateAdvisors",
      data: { advisors,accountId:getPrimaryAccount().userId },
      isBhoomiUrl:true
    };
    let cb =new Promise((resolve)=>(data.submitDone = resolve));
    this.setState({
      isSubmit:true
    },()=>{
      initiateTracking("update2", this.props.getTitle(), "", "Update");
      this.props.submitData(data);
    })
    cb.then(()=>{
      this.setState({isSubmit:false});
    })
  }

  };
  validateSecondaryAdv = addSecondaryAdv => {
    let accountAdvisorDetails = this.props.accountAdvisors;
    let accountAdvisorsArray = [];
    let secondaryAdvisorDetails = this.props.secondaryAdvisor;
    let secondaryAdvisorArray = [];
    if (accountAdvisorDetails && accountAdvisorDetails.length) {
      let obj = {};
      for (let i in accountAdvisorDetails) {
        obj["firstName"] = accountAdvisorDetails[i].firstName.toLowerCase();
        obj["lastName"] = accountAdvisorDetails[i].lastName.toLowerCase();
        obj["dob"] = accountAdvisorDetails[i].dateOfBirthStr;
      }
      accountAdvisorsArray.push(obj);
    }
    if (secondaryAdvisorDetails) {
      let newObj = {};
      newObj["firstName"] = secondaryAdvisorDetails.info.firstname.toLowerCase();
      newObj["lastName"] = secondaryAdvisorDetails.info.lastname.toLowerCase();
      newObj["dob"] = secondaryAdvisorDetails.info.dob;
      secondaryAdvisorArray.push(newObj);
    }
    if (secondaryAdvisorArray && secondaryAdvisorArray.length) {
      errorVariable = accountAdvisorsArray.filter(
        element =>
          element.firstName === secondaryAdvisorArray[0].firstName &&
          element.lastName === secondaryAdvisorArray[0].lastName &&
          element.dob === moment(secondaryAdvisorDetails.info.dob).format("MM/DD/YYYY")
      );
    }
  }
  submitData = () => { 
    try {
      const { addSecondaryAdv } = this.props;
      this.validateSecondaryAdv(addSecondaryAdv);
      if(!addSecondaryAdv) {
        if (this.props.userType === 'primary' && this.props.advisorType === "Primary") {
          let dob = this.verifyDobForInvalidDate( this.props.primaryAdvisor.info.dob);
          let firstName =  this.props.primaryAdvisor.info.firstname;
          let lastName =  this.props.primaryAdvisor.info.lastname;
          if (!(dob && firstName && lastName)) {
            this.props.myAccountMandatoryMissing(true);
            window.scrollTo(0,  this.refs.myAccountEditAdvisorWrapper.offsetTop);
          } else {
            this.updateAccountAdvisor();
          }
        } else if (this.props.userType === 'secondary' && this.props.advisorType === "Secondary") {
          let dob = this.verifyDobForInvalidDate( this.props.secondaryAdvisor.info.dob);
          let firstName =  this.props.secondaryAdvisor.info.firstname;
          let lastName =  this.props.secondaryAdvisor.info.lastname;
          if (!(dob && firstName && lastName)) {
            this.props.myAccountMandatoryMissing(true);
            window.scrollTo(0,  this.refs.myAccountEditAdvisorWrapper.offsetTop);              
          } else {
            this.updateAccountAdvisor();
          }
  
        } else {
          this.updateAccountAdvisor();
        }     
  
      } else if(this.props.userType == 'primary' && addSecondaryAdv) {
        if (errorVariable.length) {
          this.setState({
            isInvalidAdvisor: true
          })
        } else {
          if(!this.state.isSubmit)
          {
          this.setState({
            isInvalidAdvisor: false,
            isSubmit:true
          })
          let reqParams = this.createSecAdvisorBody(this.props.secondaryAdvisor);
          const data = {
            method: "POST",
            page: "MyAccountAddSecondaryAdvisor",
            url: `/DP/FinancialAccountRole/AddRole`,
            data: reqParams,
            isBhoomiUrl:true    
          };
          let cb =new Promise((resolve)=>(data.submitDone = resolve));
          this.props.addSecondaryAdvisor(data);
          cb.then(()=>{
            this.setState({isSubmit:false});
          })
        }
        }
      }
    } catch (error) {
      recordError(error);
    }  
  };
  renderNextPrimaryButton = (addr, email, phone, radio, advisorType) => {
    let em = "";
    let ph = "";
    let ad = "";
    let dm = "";
    let fn = "";
    let ln = "";
    let db = "";
    let sn = "";
    let confirmSN = "";
    let phNum = true;
    let isEmail = true;
    let isAddress = true;
    let boolVal = false;
    let infoVal = false;
    let phType = true;
    let adType = true;
    let emType = true;
    let country = true;
    let state = true;
    let gender = true;
    let lendobCheck = true;
    if (email) {
      if (this.props.isStep1Edit) {
        em = email;
      } else {
        em = email.email;
      }
    }
    if (addr) {
      if (this.props.isStep1Edit) {
        ad = addr;
      } else {
        ad = addr.addresses;
      }
    }
    if (phone) {
      if (this.props.isStep1Edit) {
        ph = phone;
      } else {
        ph = phone.phone;
      }
    }
    if (radio) {
      dm = radio.deliveryMethod;
      fn = !!radio.firstname;
      ln = !!radio.lastname;
      db = !!radio.dob;
      sn = !!radio.ssn;
      confirmSN = !!radio.confirmSSN;
      let isSame = radio.ssn === radio.confirmSSN ? true : false;
      infoVal = sn && confirmSN && isSame;
    }

    if (ad && ad.length > 0) {
      ad.forEach(val => {
        if (isAddress) {
          let zip =
            val.country === "0" ? globalRegex.uszipCode.test(val.zipcode) : globalRegex.nonUSZipCode.test(val.zipcode);
          if (
            val.addresstype &&
            val.line1 &&
            val.line1.trim() &&
            val.zipcode &&
            val.zipcode.trim() &&
            zip &&
            val.city &&
            val.city.trim() &&
            globalRegex.city.test(val.city) &&
            val.city.length > 1 &&
            val.state &&
            val.state.trim() &&
            globalRegex.state.test(val.state) &&
            val.state.length > 1 &&
            val.country &&
            val.country !== "-1"
          ) {
            isAddress = true;
          } else isAddress = false;
        }
      });
      ad.forEach(val => {
        if (adType && val.addresstype === "- Select -") {
          adType = false;
        }
      });

      ad.forEach(val => {
        if (state && val.state === "-1") {
          state = false;
        }
      });
      ad.forEach(val => {
        if (country && val.country === "-1") {
          country = false;
        }
      });
    } else {
      isAddress = false;
      adType = false;
      state = false;
      country = false;
    }
    let isprimaryPhone = false;
    let issecondaryPhone = false;
    let isPrimaryEmail = false;
    let isSecondaryEmail = false;
    if (advisorType === "Primary") {
      const primaryPhone = this.props.primaryPhone.phone && this.props.primaryPhone.phone.find(each => each.phonetype === "Primary");
      isprimaryPhone = primaryPhone && !!primaryPhone.phonenumber?.trim() ? true : false;
      const primaryEmail = this.props.primaryEmail.email && this.props.primaryEmail.email.find(each => each.emailtype === "Primary");
      isPrimaryEmail = primaryEmail && !!primaryEmail.emailId?.trim() ? true : false;
    } else if (advisorType === "Secondary") {
     
      const secondaryPhone =
        this.props.secondaryPhone.phone && this.props.secondaryPhone.phone.find(each => each.phonetype === "Primary");
      issecondaryPhone = secondaryPhone && !!secondaryPhone.phonenumber?.trim() ? true : false;
      const secondaryEmail =
        this.props.secondaryEmail.email && this.props.secondaryEmail.email.find(each => each.emailtype === "Primary");
      isSecondaryEmail = secondaryEmail && !!secondaryEmail.emailId?.trim() ? true : false;
    }
    const { addSecondaryAdv } = this.props;
    if (this.props.userType === "primary" && advisorType === "Secondary" && addSecondaryAdv) {
      lendobCheck =
        radio && radio.firstname && radio.lastname && radio.firstname.length >= 2 && radio.lastname.length >= 2 && db;
    }
    if (this.props.userType === "primary" && advisorType === "Primary") {
   
      boolVal =
        infoVal &&
        gender &&
        isprimaryPhone &&
        isPrimaryEmail &&
        isAddress &&
        adType &&
        state &&
        country &&
        dm &&
        dm !== "";
    } else if (this.props.userType === "primary" && advisorType === "Secondary" && !addSecondaryAdv) {
      boolVal = isAddress && adType && state && country;
    } else if (this.props.userType === "secondary" && advisorType === "Primary") {
      boolVal = isAddress && adType && state && country;
    } else if (
      (this.props.userType === "secondary" && advisorType === "Secondary") ||
      (this.props.userType === "primary" && advisorType === "Secondary" && addSecondaryAdv)
    ) {
 
      boolVal =
        infoVal &&
        gender &&
        issecondaryPhone &&
        isSecondaryEmail &&
        isAddress &&
        adType &&
        state &&
        country &&
        dm &&
        dm !== "";
    } else if (this.props.userType === "full" && advisorType === "Primary") {
      boolVal = isAddress && adType && state && country;
    } else if (this.props.userType === "full" && advisorType === "Secondary") {
      boolVal = isAddress && adType && state && country;
    } else {
      boolVal = false;
    }
    boolVal = boolVal && this.props.isDataChanged && lendobCheck;
    return boolVal;
  };
  closeModal = () => {
    this.setState({
      show: false
    });
  };
  handleAddAdvisorClick = () => {
    this.props.disableButton({
      disable: true
    });
    this.props.handleAddAdvisor();
    this.props.isSecondaryAdvisor({
      isSecondaryAdvisor: true
    });
    isNewSecondaryAdvisor = true;
  };
  handleRemoveAdvisorClick = () => {
    this.props.disableButton({
      disable: false
    });
    this.setState({
      show: !this.state.show,
      type: "remove"
    });
  };
  handleExit = () => {
    this.setState({
      show: true,
      type: "exit"
    });
  };
  handleExitClick = () => {
    this.setState({
      show: !this.state.show
    });
    initiateTracking("cancel2", this.props.getTitle(), "", "Cancel");
    history.push("/my-account");
  };
  handlePopUpExitClick = () => {
    this.setState({
      show: !this.state.show
    });
    initiateTracking("cancel2", this.props.getTitle(), "", "Cancel");
    history.push("/");
  };
  disabledReset = type => {
    if (type === "userInfo") {
      this.setState({
        isUserInfo: false
      });
    } else if (type === "phoneInfo") {
      this.setState({
        isPhoneInfo: false
      });
    } else if (type === "emailInfo") {
      this.setState({
        isEmailInfo: false
      });
    } else if (type === "addressInfo") {
      this.setState({
        isAddressInfo: false
      });
    }
  };
  componentWillUnmount() {
    this.props.clearEditProfileError("");
    this.props.clearSecondaryAdvRes("");
  }
  handlePhoneChange = (phone)=>{
    this.props.handlePhoneChange(
    {
      [this.advisorType.toLowerCase()+"Advisor"]: {
       ...phone
      }
    })
  }
  handleEmailChange = (email)=>{
    this.props.handleEmailChange(
    {  [this.advisorType.toLowerCase()+"Advisor"]: {
        ...email
       }}
    )
  }
  enableClearButton() {
    const { secondaryAdvisor, addSecondaryAdv, userType } = this.props;
    let info = false,
      phone = false,
      email = false,
      address = false;
    if (userType === "primary" && addSecondaryAdv && secondaryAdvisor) {
      for (let key in secondaryAdvisor.info) {
        if ((key === "title" || key === "suffix") && secondaryAdvisor.info[key] !== "-1" && secondaryAdvisor.info[key])
          info = true;
        else if (secondaryAdvisor.info[key] && key !== "deliveryMethod" && key !== "title" && key !== "suffix")
          info = true;
      }
      if (secondaryAdvisor.phone.phone)
        secondaryAdvisor.phone.phone.map(item => {
          if (item.phonenumber || item.phonetype) phone = true;
        });
      if (secondaryAdvisor.email.email)
        secondaryAdvisor.email.email.map(item => {
          if (item.emailtype || item.emailId) email = true;
        });
      if (secondaryAdvisor.addresses.addresses)
        secondaryAdvisor.addresses.addresses.map(item => {
          if (
            item.addresstype ||
            item.city ||
            item.line1 ||
            item.line2 ||
            item.line3 ||
            item.state ||
            item.zipcode ||
            item.country !== "0"
          )
            address = true;
        });
      return info || phone || email || address;
    } else {
      return true;
    }
  }
  render() {
    let isUpdateEnabled = false;
    const { addSecondaryAdv, userType, advisorType } = this.props;
    const { isUserInfo, isAddressInfo } = this.state;
    const clearAll = this.enableClearButton();
    if ((this.props.isSecondarySelected === undefined || this.props.isSecondarySelected === null) && !addSecondaryAdv) {
      isUpdateEnabled = this.renderNextPrimaryButton(
        this.props.primaryAddress,
        this.props.primaryEmail,
        this.props.primaryPhone,
        this.props.radioInfoPrimary,
        "Primary"
      );
    } else if (userType === "primary" && advisorType === "Secondary" && addSecondaryAdv) {
      isUpdateEnabled = this.renderNextPrimaryButton(
        this.props.secondaryAddress,
        this.props.secondaryEmail,
        this.props.secondaryPhone,
        this.props.radioInfoSecondary,
        "Secondary"
      );
    } else {
      isUpdateEnabled =
        this.renderNextPrimaryButton(
          this.props.primaryAddress,
          this.props.primaryEmail,
          this.props.primaryPhone,
          this.props.radioInfoPrimary,
          "Primary"
        ) &&
        this.renderNextPrimaryButton(
          this.props.secondaryAddress,
          this.props.secondaryEmail,
          this.props.secondaryPhone,
          this.props.radioInfoSecondary,
          "Secondary"
        );
    }
    return (
      <div ref="myAccountEditAdvisorWrapper">
        {this.props.myAccountMandatoryMissingFlag &&
          ((this.props.userType === "primary" && this.props.advisorType === "Primary") ||
            (this.props.userType === "secondary" && this.props.advisorType === "Secondary")) && (
            <MyAccountMandatoryMessage className="advisor-update-error-msg ">
              Some of the mandatory information is missing. Please contact us at 888-383-4483.
            </MyAccountMandatoryMessage>
          )}
        <AlertBox
          field_page="EAA"
          data-test = "alert-test"
          name="Clear Form"
          show={this.state.show && this.state.type === "reset"}
          primaryBtnEvent={() => {
            if (this.props.isStep1Edit) {
              this.handleEditReset();
            } else if (this.advisorType === "Primary") {
              this.handleReset("primaryAdvisor");
            } else {
              this.setState({
                isInvalidAdvisor: false
              });
              this.handleReset("secondaryAdvisor");
            }
          }}
          secondaryBtnEvent={() => this.closeModal()}
          defaultContent={this.resetPopupContent}
        />
        <AlertBox
          field_page="EAA"
          name="Exit Form"
          data-test = "exit-form"
          show={this.state.show && this.state.type === "exit"}
          primaryBtnEvent={() => this.handleExitClick()}
          secondaryBtnEvent={() => this.closeModal()}
          defaultContent={this.exitPopupContent}
        />
        <AlertBox
          field_page="EAA"
          name="Remove Advisor"
          data-test = "remove-advisor"
          show={this.state.show && this.state.type === "remove"}
          primaryBtnEvent={() => this.props.handleRemoveAdvisor("secondaryAdvisor")}
          secondaryBtnEvent={() => this.closeModal()}
          defaultContent={this.removePopupContent}
        />
        <AdvisoryFormWrapper>
          <FormContainer hideRequiredMark>
            <Form>
              <UserInfoForm
                dobFlag={true}
                data-test = "user-info-form"
                addSecondaryAdv={addSecondaryAdv}
                advisorType={this.advisorType}
                enableResetButton={this.enableResetButton}
                userType={this.props.userType}
                isNewSecondaryAdd={isNewSecondaryAdvisor}
                resetErrors={isUserInfo}
                disableReset={type => this.disabledReset(type)}
              />
              <PhoneForm
                data-test = "phone-form"
                phone  = {this.advisorType === "Primary"?this.props.primaryPhone.phone:this.props.secondaryPhone.phone}
                handleChange={this.handlePhoneChange}
                wrappedComponentRef = {this.phoneFormRef}
                disabled={handleDisabled({...this.props,isNewSecondaryAdvisor})}
              />
                <EmailForm
                data-test='EmailFormBlock'
                email  = {this.advisorType === "Primary"?this.props.primaryEmail.email:this.props.secondaryEmail.email}
                handleChange = {this.handleEmailChange}
                wrappedComponentRef = {this.emailFormRef}
                disabled={handleDisabled({...this.props,isNewSecondaryAdvisor})}
              />
              <AddressForm
                addSecondaryAdv={addSecondaryAdv}
                data-test = "address-form"
                advisorType={this.advisorType}
                enableResetButton={this.enableResetButton}
                userType={this.props.userType}
                isNewSecondaryAdd={isNewSecondaryAdvisor}
                resetErrors={isAddressInfo}
                disableReset={type => this.disabledReset(type)}
                zipCodeData={this.props.zipCodeData.toJS()}
                resetZipCode={(val, field) => this.props.resetZipCode(val, field)}
                resetAllZipCode={val => this.props.resetAllZipCode(val)}
              />
            </Form>
            {this.advisorType === "Secondary" && (
              <RowWrapper>
                <InfoMsg>To remove an advisor, please contact Vanguard Charitable at 888-383-4483</InfoMsg>
              </RowWrapper>
            )}
            <DividerWrap>
              <Divider />
            </DividerWrap>
            {this.state.isInvalidAdvisor === true ? (
              <ShowErrorMessage>
                The secondary advisor cannot match an existing account advisor. Please select another secondary advisor.
              </ShowErrorMessage>
            ) : (
              ""
            )}
            <DisplayFlexSpaceMobile>
              <DisplayFlex>
                <GeneralButton
                  onClick={this.handleExit}
                  text="CANCEL"
                  id={this.advisorType + "btnCancel"}
                  type="functional"
                  styling="myAccount-secondary-functional-button"
                  inverted
                  mobMargin="0 15px 15px 0"
                />

                {this.props.isStep1Edit ? (
                  this.state.enableReset ? (
                    <GhostButtonReset
                      data-test = "ghost-button-reset"
                      onClick={() =>
                        this.setState({
                          show: true,
                          type: "reset"
                        })
                      }
                      id="btnReset"
                    >
                      RESET
                    </GhostButtonReset>
                  ) : (
                    <GhostButtonReset disabled>RESET</GhostButtonReset>
                  )
                ) : (
                  <GeneralButton
                    data-test = "ghost-button"
                    onClick={() =>
                      this.setState({
                        show: !this.state.show,
                        type: "reset",
                        reset: true,
                      })
                    }
                    disabled={this.geminiUser ? true : false}
                    text="CLEAR ALL"
                    id={this.advisorType + "btnClearAll"}
                    id="btnClearAll"
                    type="functional"
                    styling="myAccount-secondary-functional-button"
                    inverted
                    mobMargin="0 0 10px 0"
                  />
                )}
              </DisplayFlex>
           
              <GeneralButton
                onClick={this.submitData}
                disabled={
                  !this.state.isSubmit && (isGeminiUser() ||
                  !isUpdateEnabled ||
                  (this.props.userType === "primary" &&
                    this.advisorType === "Primary" &&
                    addSecondaryAdv))
                }
                text={
                  this.state.isSubmit?
                  <Spinner/>:
                ( addSecondaryAdv &&
                  this.advisorType === "Secondary" &&
                  this.props.userType === "primary"
                    ? "SUBMIT"
                    : "UPDATE")
                }
                id={this.advisorType + "BtnUpdate"}
                type="functional"
                styling="myAccount-secondary-functional-update-button"
                inverted={false}
              />
            </DisplayFlexSpaceMobile>
          </FormContainer>
        </AdvisoryFormWrapper>
      </div>
    );
  }
}

const roleShapeMain = PropTypes.shape({
  name: PropTypes.any,
  primary: PropTypes.any,
  roleId: PropTypes.number,
  roleType: PropTypes.string,
  roleTypeId: PropTypes.number,
  suffix: PropTypes.any
})





const descvalueShape = PropTypes.shape({
  desc: PropTypes.string,
  value: PropTypes.string
})

const primaryAddressShape = PropTypes.shape({
  addresses: PropTypes.arrayOf(PropTypes.shape({
      addressId: PropTypes.number,
      addressUpdated: PropTypes.bool,
      addresstype: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      key: PropTypes.number,
      line1: PropTypes.string,
      line2: PropTypes.any,
      line3: PropTypes.any,
      primary: PropTypes.bool,
      state: PropTypes.string,
      zipcode: PropTypes.string
    }))
})


const emailShape = PropTypes.shape({
  email: PropTypes.arrayOf(PropTypes.shape({
        addressId: PropTypes.number,
        emailId: PropTypes.string,
        emailtype: PropTypes.string,
        key: PropTypes.number,
        primary: PropTypes.bool
      }))
})

const infoShape = PropTypes.shape({
  confirmSSN: PropTypes.string,
  deliveryMethod: PropTypes.string,
  dob: PropTypes.string,
  firstname: PropTypes.string,
  gender: PropTypes.string,
  lastname: PropTypes.string,
  middlename: PropTypes.any,
  ssn: PropTypes.string,
  suffix: PropTypes.string,
  title: PropTypes.string
})

const phoneShape = PropTypes.shape({
  phone: PropTypes.arrayOf(PropTypes.shape({
        addressId: PropTypes.number,
        key: PropTypes.number,
        phonenumber: PropTypes.string,
        phonetype: PropTypes.string,
        primary: PropTypes.bool
      }))
})


const roleShape = PropTypes.shape({
  role: roleShapeMain
})



const userIdShape = PropTypes.shape({
  userId: PropTypes.string
})

const radioInfoSecondaryShape = PropTypes.shape({
  confirmSSN: PropTypes.string,
  deliveryMethod: PropTypes.string,
  dob: PropTypes.string,
  firstname: PropTypes.string,
  gender: PropTypes.string,
  key: PropTypes.number,
  lastname: PropTypes.string,
  middlename: PropTypes.any,
  ssn: PropTypes.string,
  suffix: PropTypes.string,
  title: PropTypes.string
})

const relatedDonorShape = PropTypes.object;
 AdvisorForm.propTypes = {
  accountAdvisors: PropTypes.any,
    accountName: PropTypes.any,
    addSecondaryAdv: PropTypes.bool,
    addSecondaryAdvisor: PropTypes.func,
    addSecondaryRes: PropTypes.shape({
    caseNumber: PropTypes.any
  }),
    advisorType: PropTypes.string,
    apiData: PropTypes.arrayOf(PropTypes.shape({
      accountId: PropTypes.any,
      accountNumber: PropTypes.any,
      address: PropTypes.any,
      addresses: PropTypes.arrayOf(PropTypes.shape({
        address: PropTypes.any,
        addressId: PropTypes.number,
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.any,
        addressLine3: PropTypes.any,
        addressType: PropTypes.string,
        addressUpdated: PropTypes.bool,
        city: PropTypes.string,
        country: PropTypes.string,
        primary: PropTypes.number,
        state: PropTypes.string,
        zipCode: PropTypes.string
      })),
      convertedLogin: PropTypes.any,
      dateOfBirthStr: PropTypes.string,
      deliveryMethod: PropTypes.string,
      dob: PropTypes.number,
      dobStr: PropTypes.any,
      email: PropTypes.any,
      emails: PropTypes.arrayOf(PropTypes.shape({
        addressId: PropTypes.number,
        emailId: PropTypes.string,
        emailType: PropTypes.string,
        primary: PropTypes.number
      })),
      firstName: PropTypes.string,
      gender: PropTypes.string,
      lastName: PropTypes.string,
      marritalStatus: PropTypes.any,
      middleName: PropTypes.any,
      name: PropTypes.any,
      partyId: PropTypes.number,
      permissionToShare: PropTypes.any,
      phone: PropTypes.any,
      phones: PropTypes.arrayOf(PropTypes.shape({
        addressId: PropTypes.number,
        phoneNumber: PropTypes.string,
        phoneType: PropTypes.string,
        primary: PropTypes.number
      })),
      preferredContactMethod: PropTypes.any,
      primary: PropTypes.bool,
      primaryAccountContact: PropTypes.bool,
      referralComments: PropTypes.any,
      referralValue: PropTypes.any,
      relatedDonor: PropTypes.any,
      role: roleShapeMain,
      ssn: PropTypes.string,
      suffix: PropTypes.string,
      title: PropTypes.string,
      userId: PropTypes.string,
      webAccess: PropTypes.any
    })),
  clearEditProfileError: PropTypes.func,
  clearSecondaryAdvRes: PropTypes.func,
  disableButton: PropTypes.func,
  dropdownValues: PropTypes.shape({
    countries: PropTypes.arrayOf(descvalueShape),
    dollarPotential: PropTypes.arrayOf(descvalueShape),
    emaileAddressTypes: PropTypes.arrayOf(descvalueShape),
    gender: PropTypes.arrayOf(descvalueShape),
    grantRecognition: PropTypes.arrayOf(descvalueShape),
    phoneAddressTypes: PropTypes.arrayOf(descvalueShape),
    postalAddressTypes: PropTypes.arrayOf(descvalueShape),
    states: PropTypes.arrayOf(descvalueShape),
    suffix: PropTypes.arrayOf(descvalueShape),
    title: PropTypes.arrayOf(descvalueShape)
  }),
    getTitle: PropTypes.func,
  handleAddAdvisor: PropTypes.func,
  handleRemoveAdvisor: PropTypes.func,
  handleResetFormAddress: PropTypes.func,
  handleResetFormEmail: PropTypes.func,
  handleResetFormInfo: PropTypes.func,
  handleResetFormPhone: PropTypes.func,
  handleResetFormRelatedContributor: PropTypes.func,
  handleResetSecFormBasicInfo: PropTypes.func,
  isDataChanged: PropTypes.bool,
  isSecondaryAdvisor: PropTypes.func,
    isSecondarySelected: PropTypes.shape({
      isSecondaryAdvisor: PropTypes.bool
    }),
    isStep1Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  legacyOptions: PropTypes.array,
  myAccountMandatoryMissing: PropTypes.func,
  myAccountMandatoryMissingFlag: PropTypes.bool,
  primaryAddress: primaryAddressShape,
  primaryAdvisor: PropTypes.shape({
    addresses: primaryAddressShape,
    disable: PropTypes.bool,
    email: emailShape,
    info: infoShape,
    phone: phoneShape,
    relatedDonor: PropTypes.shape({
      relatedDonor: PropTypes.arrayOf(PropTypes.any)
    }),
    reset: PropTypes.bool,
    role: roleShape,
    userId: userIdShape
  }),
  primaryEmail: emailShape,
  primaryPhone: phoneShape,
  radioInfoPrimary: infoShape,
  radioInfoSecondary: radioInfoSecondaryShape,
  reset: PropTypes.func,
  resetAllZipCode: PropTypes.func,
  resetZipCode: PropTypes.func,
  secondaryAddress: primaryAddressShape,
  secondaryAdvisor: PropTypes.shape({
    addresses: primaryAddressShape,
    email: emailShape,
    info: radioInfoSecondaryShape,
    phone: phoneShape,
    relatedDonor: relatedDonorShape,
    reset: PropTypes.bool,
    role: roleShape,
    userId: userIdShape
  }),
  secondaryEmail: emailShape,
  secondaryPhone: phoneShape,
    submitData: PropTypes.func,
  userType: PropTypes.string,
  webAccessInfo: PropTypes.shape({
    fundName: PropTypes.string,
    userId: PropTypes.string
  }),
  zipCodeData: relatedDonorShape
};




const WrappedAdvisoryForm = Form.create({ name: "advisor" })(AdvisorForm);
const mapStateToProps = state => ({
  primaryEmail: state.getIn(["myAccount", "primaryAdvisor", "email"]),
  secondaryEmail: state.getIn(["myAccount", "secondaryAdvisor", "email"]),
  primaryPhone: state.getIn(["myAccount", "primaryAdvisor", "phone"]),
  secondaryPhone: state.getIn(["myAccount", "secondaryAdvisor", "phone"]),
  primaryAddress: state.getIn([
    "myAccount",
    "primaryAdvisor",
    "addresses"
  ]),
  primaryDeletedAddress: state.getIn([
    "myAccount",
    "primaryAdvisor",
    "deletedAddress"
  ]),
  secondaryAddress: state.getIn([
    "myAccount",
    "secondaryAdvisor",
    "addresses"
  ]),
  secondaryDeletedAddress: state.getIn([
    "myAccount",
    "secondaryAdvisor",
    "deletedAddress"
  ]),
  webAccessInfo: state.getIn(["myAccount", "webAccessInfo"]).toJS(),
  legacyOptions: state.getIn(["myAccount", "legacyOptions", "legacyOptions", "legacyOptions"]),
  primaryAdvisor: state.getIn(["myAccount", "primaryAdvisor"]).toJS(),
  secondaryAdvisor: state.getIn(["myAccount", "secondaryAdvisor"]).toJS(),
  radioInfoPrimary: state.getIn(["myAccount", "primaryAdvisor", "info"]),
  radioInfoSecondary: state.getIn([
    "myAccount",
    "secondaryAdvisor",
    "info"
  ]),
  disable: state.getIn(["myAccount", "primaryAdvisor", "disable"]),
  activePageStepNumber: state.getIn(["globalState", "activePageStepNumber"]),
  stepperConfig: state.getIn(["globalState", "stepperConfig"]),
  isStep1Edit: state.getIn(["myAccount", "isStep1Edit", "isStep1Edit", "isStep1Edit"]),
  tempData: state.getIn(["myAccount", "tempJSON", "tempJSON"]),
  accountName: state.getIn(["myAccount", "fundName", "fundName", "fundName"]),
  isSecondarySelected: state.getIn(["myAccount","isSecondaryAdvisor","isSecondaryAdvisor"]),
  isDataChanged: state.getIn(["myAccount","isDataChanged","changed"]),
  apiData: state.getIn(["myAccount","editAdvisorAPIData","data","advisors"]),
  isError: state.getIn(["myAccount","submitEditAdvisorError","isError"]),
  dropdownValues: state.getIn(["myAccount", "dropdownValues", "data"]),
  addSecondaryRes: state.getIn(["myAccount", "secondaryAdvisorRes", "success"]),
  myAccountMandatoryMissingFlag: state.getIn(["myAccount", "myAccountMandatoryMissingFlag"]),
  zipCodeData: state.getIn(['zipCode', 'zipCodes']),
  accountAdvisors: state.getIn(["myAccount", "accountData", "data", "accountAdvisors"]),
 
});
export const mapDispatchToProps = dispatch => {
  return {
    handleResetFormAddress: arr => dispatch(handleResetFormAddress(arr)),
    handleResetFormPhone: arr => dispatch(handleResetFormPhone(arr)),
    handleResetFormEmail: arr => dispatch(handleResetFormEmail(arr)),
    handleResetFormInfo: arr => dispatch(handleResetFormInfo(arr)),
    reset: val => dispatch(reset(val)),
    disableButton: val => dispatch(disableButton(val)),
    handleResetFormRelatedContributor: arr =>
    dispatch(handleResetFormRelatedContributor(arr)),
    finishActivePageStep: () => dispatch(updatePageStepToFinish()),
    isSecondaryAdvisor: val => dispatch(isSecondaryAdvisor(val)),
    step1Edit: val => dispatch(step1Edit(val)),
    jsonTemp: val => dispatch(jsonTemp(val)),
    submitData: (data) => dispatch(postAccountAdvisor(data)),
    clearEditProfileError: (data) => dispatch(clearEditProfileError(data)),
    addSecondaryAdvisor: (data) => dispatch(addSecondaryAdvisor(data)),
    clearSecondaryAdvRes: (data) => dispatch(clearSecondaryAdvRes(data)),
    handleResetSecFormBasicInfo: (data) => dispatch(handleResetSecFormBasicInfo(data)),
    myAccountMandatoryMissing: (data) => dispatch(myAccountMandatoryMissing(data)),
    resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
    resetAllZipCode: (val) => dispatch(resetAllZipFields(val)),
    handleEmailChange: arr => dispatch(onEmailChangeHandler(arr)),
    handlePhoneChange: arr => dispatch(onPhoneChangeHandler(arr))
  }
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedAdvisoryForm);
